import { mergeStateParts } from 'Modules/core/redux';

import { info } from './info';
import { news } from './news';
import { documents } from './documents';
import { emission } from './emission';
import { feedback } from './feedback';
import { monitoring } from './monitoring';


export const state = mergeStateParts('landing-dfa', {
    info,
    news,
    documents,
    emission,
    feedback,
    monitoring,
});
